import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import PeriodPicker from 'pages/parts/PeriodPicker'
import { formatMoney, formatDate } from 'helpers/helpers'
import { httpOk, GET } from 'helpers/api'

// Расход SMS. Главное здесь не «сколько отправили», а маржа: списано с клиента
// против нашей себестоимости. Без этой пары не видно, не работаем ли мы в минус
// на длинных шаблонах или на дорогом направлении.
function Index() {
	const { t } = useTranslation()

	const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
	const [filterData, setFilterData] = useState({
		'start_date': formatDate(firstDay, 'yyyy-MM-dd'),
		'end_date': formatDate(new Date(), 'yyyy-MM-dd'),
		'search': '',
	})
	const [data, setData] = useState({})

	async function loadData(filter = filterData) {
		var url = `/admin/sms-report?start_date=${filter.start_date}&end_date=${filter.end_date}`
		if (filter.search) url += `&search=${filter.search}`

		const response = await GET(url, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		loadData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const summary = data.summary || {}

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('sms_report')}</h4>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="form-group col-md-6">
							<label>{t('period')}</label>
							<PeriodPicker
								startDate={filterData.start_date}
								endDate={filterData.end_date}
								onChange={(period) => setFilterData({ ...filterData, ...period })}
								withTime={false}
							/>
						</div>
						<div className="form-group col-md-3">
							<label>{t('login')}</label>
							<input type="text" className="form-control" value={filterData.search}
								onChange={(e) => setFilterData({ ...filterData, 'search': e.target.value })} />
						</div>
						<div className="form-group col-md-3">
							<label className="invisible">.</label>
							<button className="btn btn-primary w-100" onClick={() => loadData()}>{t('apply')}</button>
						</div>
					</div>
				</div>
			</div>

			<div className="row mb-3">
				<div className="col-md-3">
					<div className="card h-100"><div className="card-body">
						<div className="text-muted">{t('sms_status_sent')}</div>
						<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>{formatMoney(summary.sent || 0)}</div>
					</div></div>
				</div>
				<div className="col-md-3">
					<div className="card h-100"><div className="card-body">
						<div className="text-muted">{t('sms_spent')}</div>
						<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>{formatMoney(summary.amount || 0)}</div>
					</div></div>
				</div>
				<div className="col-md-3">
					<div className="card h-100"><div className="card-body">
						<div className="text-muted">{t('sms_cost')}</div>
						<div className="fw-600" style={{ 'fontSize': '1.2rem' }}>{formatMoney(summary.cost || 0)}</div>
					</div></div>
				</div>
				<div className="col-md-3">
					<div className="card h-100"><div className="card-body">
						<div className="text-muted">{t('sms_margin')}</div>
						<div className={'fw-600 ' + ((summary.margin || 0) < 0 ? 'text-danger' : 'text-success')}
							style={{ 'fontSize': '1.2rem' }}>
							{formatMoney(summary.margin || 0)}
						</div>
					</div></div>
				</div>
			</div>

			<div className="row">
				<div className="col-md-7">
					<div className="card">
						<div className="card-body">
							<h6>{t('clients')}</h6>
							<div className="table-responsive">
								<table className="table table-bordered">
									<thead>
										<tr>
											<th>{t('login')}</th>
											<th className="text-end">{t('sms_status_sent')}</th>
											<th className="text-end">{t('sms_status_failed')}</th>
											<th className="text-end">{t('sms_spent')}</th>
											<th className="text-end">{t('sms_cost')}</th>
										</tr>
									</thead>
									<tbody>
										{(data.by_client || []).map((item, index) => (
											<tr key={index}>
												<td>{item.login}</td>
												<td className="text-end">{formatMoney(item.sent)}</td>
												<td className="text-end">{formatMoney(item.failed)}</td>
												<td className="text-end">{formatMoney(item.amount)}</td>
												<td className="text-end">{formatMoney(item.cost)}</td>
											</tr>
										))}
										{(data.by_client || []).length === 0 &&
											<tr><td colSpan="5" className="text-center text-muted">{t('list_empty')}</td></tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-5">
					<div className="card mb-3">
						<div className="card-body">
							<h6>{t('sms_upstreams')}</h6>
							<div className="table-responsive">
								<table className="table table-bordered">
									<thead>
										<tr>
											<th>{t('name')}</th>
											<th>{t('sms_countries')}</th>
											<th className="text-end">{t('sms_status_sent')}</th>
											<th className="text-end">{t('sms_margin')}</th>
										</tr>
									</thead>
									<tbody>
										{(data.by_upstream || []).map((item, index) => (
											<tr key={index}>
												<td>{item.upstream_name}</td>
												<td>{item.country_code}</td>
												<td className="text-end">{formatMoney(item.sent)}</td>
												<td className={'text-end ' + ((item.amount - item.cost) < 0 ? 'text-danger' : '')}>
													{formatMoney(item.amount - item.cost)}
												</td>
											</tr>
										))}
										{(data.by_upstream || []).length === 0 &&
											<tr><td colSpan="4" className="text-center text-muted">{t('list_empty')}</td></tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>

					{/* Отказы — это упущенные уведомления: пустой баланс клиента или страна без договора */}
					<div className="card">
						<div className="card-body">
							<h6>{t('sms_status_failed')}</h6>
							<div className="table-responsive">
								<table className="table table-bordered">
									<tbody>
										{(data.failures || []).map((item, index) => (
											<tr key={index}>
												<td>{item.reason}</td>
												<td className="text-end">{formatMoney(item.count)}</td>
											</tr>
										))}
										{(data.failures || []).length === 0 &&
											<tr><td colSpan="2" className="text-center text-muted">{t('list_empty')}</td></tr>
										}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Index
